import styled from 'styled-components';
import { theme } from '@/styles/theme';

interface SectionProps {
  $background?: string;
  $padding?: 'small' | 'medium' | 'large';
}

export const Section = styled.section<SectionProps>`
  width: 100%;
  background: ${({ $background }) => $background || theme.colors.white};
  padding: ${({ $padding }) => {
    switch ($padding) {
      case 'small':
        return '40px 0';
      case 'large':
        return '120px 0';
      default:
        return '80px 0';
    }
  }};

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: ${({ $padding }) => {
      switch ($padding) {
        case 'small':
          return '24px 0';
        case 'large':
          return '64px 0';
        default:
          return '48px 0';
      }
    }};
  }
`;
